/**
 * iOS Safari 兼容性工具
 *
 * X6 的 pageToLocal 已经正确处理坐标转换，无需额外处理 visual viewport 偏移。
 */

/**
 * 将事件坐标（clientX/Y）转换为画布本地坐标
 * 直接调用 X6 的 pageToLocal，无需额外处理
 */
export function safePageToLocal(
  graph: any,
  clientX: number,
  clientY: number,
): { x: number; y: number } {
  return graph.pageToLocal(clientX, clientY);
}

/**
 * 从鼠标或触摸事件中提取坐标
 */
export function getEventClientXY(e: any): { clientX: number; clientY: number } {
  if (e.touches && e.touches.length > 0) {
    return { clientX: e.touches[0].clientX, clientY: e.touches[0].clientY };
  }
  if (e.changedTouches && e.changedTouches.length > 0) {
    return { clientX: e.changedTouches[0].clientX, clientY: e.changedTouches[0].clientY };
  }
  return { clientX: e.clientX, clientY: e.clientY };
}
